import { Lozenge } from "@/domains/common/components/lozenge"

export const DisplayLevel = ({ lockValue, size = "xs" }: { lockValue: number; size?: "xs" | "xxs" }) => {
  if (lockValue > 5000) {
    return (
      <Lozenge color="scalest" size={size}>
        Scalest
      </Lozenge>
    )
  }

  return (
    <Lozenge color={"scalar"} size={size}>
      Scalar
    </Lozenge>
  )
}
